export default "__VITE_ASSET__8dac0052__"